export default __webpack_public_path__ + "static/media/rnr-sports-table-21-cn.bbb1bf49.webp";